/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import Base64Url from 'base64url';
import * as crypto from 'crypto-browserify';

@Injectable()
export class RegistrationValidateTokenService {
	public constructor(private loggingService: LoggingService) {}

	public validate(token: string): boolean {
		try {
			const jwtParts = token.split('.');

			const jwtHeader = jwtParts[0];
			const jwtPayload = jwtParts[1];
			const jwtSignature = jwtParts[2];

			const verifyFunction = crypto.createVerify('RSA-SHA256');
			verifyFunction.write(jwtHeader + '.' + jwtPayload);
			verifyFunction.end();

			const jwtSignatureBase64 = Base64Url.toBase64(jwtSignature);

			let public_key = '-----BEGIN PUBLIC KEY-----';
			public_key += 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDVK2aDNSTFL4Plh53tWrx+ZjG4';
			public_key += 'f23gXN+vOawPTPzKNO2Sud5AEi+n/8zKM7unWrawAE88wX9gX5v2D73FYE4tN4yu';
			public_key += 'SQ2fxm5fDLgGbbU00m548EfvNtHP+WDUHz2rAN5cEbe2jGjRlSLXMreekBhstRVx';
			public_key += 'BttX3Uyw5TB7tYxlCQIDAQAB';
			public_key += '-----END PUBLIC KEY-----';

			const signatureIsValid = verifyFunction.verify(public_key, jwtSignatureBase64, 'base64');
			// console.log(jwtHeader, "RegistrationValidateTokenService");
			// console.log(jwtPayload, "RegistrationValidateTokenService");
			return signatureIsValid;
		} catch (error) {
			this.loggingService.error(ErrorCodes.ValidateRegistrationToken, error);
			throw error;
		}
	}
}
